import { render, staticRenderFns } from "./videoModal.vue?vue&type=template&id=5ccfca0e&scoped=true&"
import script from "./videoModal.vue?vue&type=script&lang=js&"
export * from "./videoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccfca0e",
  null
  
)

export default component.exports